export function deepClone<T>(obj: T): T {
  if (Array.isArray(obj)) {
    // @ts-expect-error missing type
    return obj.map((item) => deepClone(item))
  } else if (typeof obj === 'object' && obj !== null) {
    const clone = {}
    for (const key in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(key)) {
        // @ts-expect-error missing type
        clone[key] = deepClone(obj[key])
      }
    }
    // @ts-expect-error missing type
    return clone
  } else {
    return obj
  }
}
